<template lang="html">
	<div>
	<div class="profile-item">
		<div class="name">{{ profile.name }}</div>
		<div class="price"><span class="name">{{ $t('profileCost') }}:</span><span class="value">{{ fullPrice }}</span></div>
		<div class="paper"><span class="name">{{ $t('paperName') }}:</span><span class="value">{{ profile.paper.name }}</span></div>
	</div>
	<el-divider></el-divider>
	</div>
</template>
<script>
export default {
	name: "ProfileItem",
	computed: {
		fullPrice: function () {
			if (this.profile.price > 0) {
				return `${this.profile.price} ${this.spot.symbol}`;
			}
			return this.$t('priceFree');
		}
	},
	props: {
		profile: Object,
		spot:    Object
	},
	data: () => ({
	}),
	methods: {
	}
}
</script>
<style lang="scss" scoped>
.profile-item {
	margin-bottom: 0.5em;
	margin-top:0.5em;
	.name {
		font-size: 16px;
		font-weight: bold;
		color: #424242;
		padding-bottom:.5em;
		padding-top:.5em;
	}
	.paper {
		padding: 0.25em 0;
		color: #777;
		.name {
			font-weight: normal;
			padding-right:0.5em;
		}
		.value {
			font-weight: bold;
		}
	}
	.price {
		padding: 0.25em 0;
		color: #777;
		.name {
			font-weight: normal;
			padding-right:0.5em;
		}
		.value {
			font-weight: bold;
		}
	}
}
</style>